import { ReactNode } from "react";

/**
 * 왜 비용이 다를까요? 섹션
 * - 3가지 변동 요인 (빈소 크기, 조문 인원, 옵션 선택)
 * - "비용 범위가 왜 넓은지" 정직 설명 - 광고 검수 신뢰감 + 사용자 의구심 해소
 * - children: 섹션 하단에 CTA 등 슬롯
 */

const REASONS = [
  {
    num: "01",
    title: "빈소 크기",
    desc: "대형·중형·소형 빈소에 따라 사용료가 달라집니다.",
  },
  {
    num: "02",
    title: "조문 인원",
    desc: "예상 조문객 규모에 따라 음식·접객 비용이 결정됩니다.",
  },
  {
    num: "03",
    title: "옵션 선택",
    desc: "음식 메뉴, 꽃 제단, 장지(매장·화장) 등 가족이 선택하는 항목이 가격을 좌우합니다.",
  },
];

interface QuoteWhyDifferentProps {
  children?: ReactNode;
}

export const QuoteWhyDifferent = ({
  children,
}: QuoteWhyDifferentProps = {}) => {
  return (
    <section className="lp-why">
      <h2>비용 확인 시 고려할 점</h2>
      <ul className="lp-why-list">
        {REASONS.map((reason) => (
          <li key={reason.num} className="lp-why-item">
            <div className="lp-why-num">{reason.num}</div>
            <div className="lp-why-body">
              <div className="lp-why-title">{reason.title}</div>
              <div className="lp-why-desc">{reason.desc}</div>
            </div>
          </li>
        ))}
      </ul>
      {children}
    </section>
  );
};
